// import { ArrayData as AdminAccountantRoutes } from "../../navigation/routes/AdminAccountantRoutes";
// import { ArrayData as ClientListRoutes } from "../../navigation/routes/ClientListRoutes";
// import { ArrayData as ClientListRoutesWithAccountant } from "../../navigation/routes/ClientListRoutesWithAccountant";
// import { ArrayData as AccountantListRoutes } from "../../navigation/routes/AccountantListRoutes";
// import { ArrayData as ClientRoutes } from "../../navigation/routes/ClientRoutes";
// import { ArrayData as AdminClientRoutes, ArrayData } from "../../navigation/routes/AdminClientRoutes";
// import { ArrayData as AdminRoutes } from "../../navigation/routes/AdminRoutes";

import "./RoleBasedLeftMenu.css"; // Default
import "./RoleBasedTopMenuBar.css"; // Ensure this file exists and styles top menu

import { AccountantService, AuthService } from "../../services";
import { FC, useEffect, useMemo, useState } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { PanelMenu, PanelMenuPassThroughOptions } from "primereact/panelmenu";
import {
	clearSelectedAccountant,
	clearSelectedAccountantName,
	clearSelectedClient,
	clearSelectedTaxYear,
	setAppBarSelectedItem,
	setSelectedClient,
	setSelectedDrawerMenu,
	setSelectedHomePage,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";

import { AccountantListRoutesComponent } from "./routes/AccountantListRoutes";
import { AdminAccountantRoutesComponent } from "./routes/AdminAccountantRoutes";
import { AdminClientRoutesComponent } from "./routes/AdminClientRoutes";
import { AdminRoutesComponent } from "./routes/AdminRoutes";
import { ClientListRoutesComponent } from "./routes/ClientListRoutes";
import { ClientListRoutesWithAccountantComponent } from "./routes/ClientListRoutesWithAccountant";
import { ClientRoutesComponent } from "./routes/ClientRoutes";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { LeftMenu } from "../LeftMenu";
import LogoutIcon from "@mui/icons-material/Logout";
import MultiLevelDrawer from "./MultiLevelDrawer";
import SingleMenubar from "./SingleMenubar";
import { TieredMenu } from "primereact/tieredmenu";
import { classNames } from "primereact/utils";
import { consoleValue } from "../../common/Common";
import { useQuery } from "@tanstack/react-query";

// import { clearAccountantId, clearAccountantName, clearClientId, clearClientName, clearTaxYear, goToAccList } from "../../common/Common";




















// import { IGetListRequest } from "models";

// import { accountantservice } from "services";
// import { homePageReducer } from "store/reducers/homePageReducers";






// import { PanelMenu } from "primereact/panelmenu";
// import { AdminAccountantRoutesComponent } from "../RoleBasedTopMenuBar/routes/AdminAccountantRoutes";
// import { ClientListRoutesComponent } from "../RoleBasedTopMenuBar/routes/ClientListRoutes";
// import { ClientListRoutesWithAccountantComponent } from "../RoleBasedTopMenuBar/routes/ClientListRoutesWithAccountant";
// import { AccountantListRoutesComponent } from "../RoleBasedTopMenuBar/routes/AccountantListRoutes";
// import { ClientRoutesComponent } from "../RoleBasedTopMenuBar/routes/ClientRoutes";
// import { AdminClientRoutesComponent } from "../RoleBasedTopMenuBar/routes/AdminClientRoutes";
// import { AdminRoutesComponent } from "../RoleBasedTopMenuBar/routes/AdminRoutes";
// import "./RoleBasedLeftMenu.css";












// Conditionally import CSS




// const useAccountants = (params: IGetListRequest, isAdminUser: number, selectedAccountantId: string) =>
// 	useQuery({
// 		queryKey: ["accountants-list", params, isAdminUser, selectedAccountantId],
// 		queryFn: (data) => {
// 			return AccountantService.getAccountantsToManageNavBar(params, isAdminUser, selectedAccountantId);
// 		},
// 		refetchOnWindowFocus: false
// 	}
// 	);

const useGetRoleMenuAndPermissions = (isApiCalls: boolean, roleIds: { id: string; expiresAt: string | null }[], clientId: string, accountantId: string, isAdminUser: number, companyAccountantName: string | null) =>
	useQuery({
		queryKey: ["role-menu-and-permissions", isApiCalls, roleIds, clientId, accountantId, isAdminUser, companyAccountantName],
		queryFn: (data) => {
			return AuthService.getRoleMenuAndPermissions(isApiCalls, roleIds, clientId, accountantId, isAdminUser, companyAccountantName);
		},
		refetchOnWindowFocus: false
	}
	);

type RawMenuItem = {
	name: string;
	url?: string | null;
	category?: string;
	items?: RawMenuItem[];
};

type MenuItem = {
	label: string;
	items?: MenuItem[];
	command?: () => void;
	template?: (item: any, options: any) => React.ReactNode;
};


interface IRoleBasedLeftMenu {
	isAppBar: boolean;
	isSmallScreenMenu?: boolean;
}
export const RoleBasedLeftMenu: FC<IRoleBasedLeftMenu> = ({ isAppBar, isSmallScreenMenu = false }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	let {
		isAdminUser,
		token,
		companyAccountantName,
		roleId,
		selectedAccountantId,
		selectedAccountantName,
		selectedClientId,
		selectedClientName,
		selectedYear,
		// invoiceRefNo, CSVInformationUI,
		HomePagePath,
		selectedMenuItem,
		drawerAction,
		subMenuVisibility,
		activityLog,
		drawerMenu,
		drawerMenuOptions,
		// isLoadAxiosCall,
		stickyNavBar,
		countryAndProvincesInfo,
		dashboardApisData,
		lastBankScreen,
		companySequenceNumber
	} = useSelector((state: IAppState) => {
		return {
			isAdminUser: state.user.profile.isSuperStatus,
			token: state.user.token,
			companyAccountantName: state.user.profile.companyAccountantName,
			roleId: state.user.profile.roleId,
			selectedAccountantId: state.accountant.id,
			selectedAccountantName: state.accountant.AccountantName,
			selectedClientId: state.client.id,
			selectedClientName: state.client.clientName,
			selectedYear: state.taxYear.year,
			// invoiceRefNo: state.invoice.refNo,
			// CSVInformationUI: state.CSVInformationUI,
			HomePagePath: state.HomePagePath.path,
			selectedMenuItem: state.navigation.selectedMenuItem,
			drawerAction: state.drawerAction.open,
			subMenuVisibility: state.drawerAction.subMenuVisibility,
			activityLog: state.activityLog,
			drawerMenu: state.drawerMenu,
			drawerMenuOptions: state.drawerMenuOptions,
			// isLoadAxiosCall:state.isLoadAxiosCall.isLoading,
			stickyNavBar: state.stickyNavBar.isSticky,
			countryAndProvincesInfo: state.countryAndProvincesInfo,
			dashboardApisData: state.dashboardApisData,
			screenFirstPoint: state.drawerMenuOptions.screenFirstPoint,
			lastBankScreen: state.user.profile.lastBankScreen,
			companySequenceNumber: state.user.profile.companySequenceNumber,
		};
	});

	const appBarSelectedItem = useSelector(
		(state: IAppState) => state.drawerAction.appBarSelectedItem
	);

	const { AdminAccountantRoutes } = AdminAccountantRoutesComponent();
	const { ClientListRoutes } = ClientListRoutesComponent();
	const { ClientListRoutesWithAccountant } =
		ClientListRoutesWithAccountantComponent();
	const { AccountantListRoutes } = AccountantListRoutesComponent();
	const { ClientRoutes } = ClientRoutesComponent();
	const { AdminClientRoutes } = AdminClientRoutesComponent();
	const { AdminRoutes } = AdminRoutesComponent();
	const [roleMenuAndPermissionsData, setRoleMenuAndPermissionsData] = useState<any>(undefined)

	const clearClientId = () => {
		dispatch(clearSelectedClient());
	};
	const clearClientName = () => {
		dispatch(clearSelectedClient());
	};
	const clearAccountantId = () => {
		dispatch(clearSelectedAccountant());
	};
	const clearAccountantName = () => {
		dispatch(clearSelectedAccountantName());
	};
	const clearTaxYear = () => {
		dispatch(clearSelectedTaxYear());
	};
	const goToAccList = () => {
		dispatch(setAppBarSelectedItem({ appBarSelectedItem: "Accountant" }))
	};
	const goToHome = () => {
		dispatch(setAppBarSelectedItem({ appBarSelectedItem: "Home" }))
	};
	const superUserFieldsShownInClientSetup = () => {
		dispatch(setSelectedClient({ superUserFieldsShownInClientSetup: true }));
	};

	// const convertMenuData = (
	// 	data: RawMenuItem[],
	// 	navigate: NavigateFunction
	// ): MenuItem[] => {
	// 	return data.map((item) => {
	// 		const menuItem: MenuItem = {
	// 			label: item.name
	// 		};

	// 		// If URL exists → add command
	// 		if (item.name === "Super User") {
	// 			clearClientId();
	// 			clearClientName();
	// 			clearAccountantId();
	// 			clearAccountantName();
	// 			clearTaxYear();
	// 			goToAccList()
	// 			menuItem.command = () => navigate(item.url!);
	// 		}
	// 		if (item.name === "Accountant List") {
	// 			clearAccountantId();
	// 			clearAccountantName();
	// 			clearClientId();
	// 			clearClientName();
	// 			clearTaxYear();
	// 			menuItem.command = () => navigate(item.url!);
	// 		}
	// 		if (item.name === "Client List") {
	// 			clearClientId();
	// 			clearClientName();
	// 			clearTaxYear();
	// 			menuItem.command = () => navigate(item.url!);
	// 		}
	// 		if (item.name === "Global Search") {
	// 			clearClientId();
	// 			clearClientName();
	// 			clearAccountantId();
	// 			clearAccountantName();
	// 			clearTaxYear();
	// 			goToHome()
	// 			menuItem.command = () => navigate(item.url!);
	// 		}
	// 		if (item.url) {
	// 			menuItem.command = () => navigate(item.url!);
	// 		}

	// 		// If children exist → recurse
	// 		if (item.items && item.items.length > 0) {
	// 			menuItem.items = convertMenuData(item.items, navigate);
	// 		}

	// 		return menuItem;
	// 	});
	// };

	const resetActions: Record<string, () => void> = {
		"Super User": () => {
			clearClientId();
			clearClientName();
			clearAccountantId();
			clearAccountantName();
			clearTaxYear();
			goToAccList();
		},
		"Accountant List": () => {
			clearAccountantId();
			clearAccountantName();
			clearClientId();
			clearClientName();
			clearTaxYear();
		},
		"Client List": () => {
			clearClientId();
			clearClientName();
			clearTaxYear();
		},
		"Global Search": () => {
			clearClientId();
			clearClientName();
			clearAccountantId();
			clearAccountantName();
			clearTaxYear();
			goToHome();
		},
		"Client Setup": () => {
			superUserFieldsShownInClientSetup();
		}
	};


	// FOR ADD-ONS header Show
	const sectionHeadingTemplate = (item: any) => (
		<div className="panel-menu-header">{item.label}</div>
	);

	// Walks a sibling list and inserts a non-clickable heading item
	// right before each new contiguous run of items sharing the same category.
	// Items without a category pass through untouched, no heading is added.
	const insertHeadingRuns = (
		data: RawMenuItem[]
	): (RawMenuItem & { isHeading?: boolean })[] => {
		const result: (RawMenuItem & { isHeading?: boolean })[] = [];
		let lastCategory: string | undefined;

		data.forEach((item: any) => {
			if (item.category && item.category !== lastCategory) {
				result.push({ name: item.category, isHeading: true });
			}
			result.push(item);
			lastCategory = item.category; // resets automatically when category is absent
		});

		return result;
	};

	const convertMenuData = (
		data: RawMenuItem[],
		navigate: NavigateFunction
	): MenuItem[] =>
		insertHeadingRuns(data).map((item: any) => {
			if (item.isHeading) {
				return {
					label: item.name,
					template: sectionHeadingTemplate,
				};
			}
			return {
				label: item.name,
				command: item.url
					? () => {
						resetActions[item.name]?.();
						navigate(item.url);
					}
					: undefined,
				items: item.items?.length
					? convertMenuData(item.items, navigate)
					: undefined
			};
		});

	// const convertMenuData = (
	// 	data: RawMenuItem[],
	// 	navigate: NavigateFunction
	// ): MenuItem[] =>
	// 	data.map((item: any) => ({
	// 		label: item.name,
	// 		command: item.url
	// 			? () => {
	// 				resetActions[item.name]?.();
	// 				navigate(item.url);
	// 			}
	// 			: undefined,
	// 		items: item.items?.length
	// 			? convertMenuData(item.items, navigate)
	// 			: undefined
	// 	}));


	// const roleIds = roleId.map(({ id }) => id);
	const [isApiCalls, setIsApiCalls] = useState(false);
	const { data: roleMenuAndPermissions } = useGetRoleMenuAndPermissions(isApiCalls, roleId, selectedClientId, selectedAccountantId, isAdminUser, companyAccountantName);

	useEffect(() => {
		if (lastBankScreen === 300 || lastBankScreen === 400) {
			setIsApiCalls(true)
		}
	}, [lastBankScreen])


	useEffect(() => {
		if (roleMenuAndPermissions && roleMenuAndPermissions.menu_data) {
			let menu: any = (convertMenuData(roleMenuAndPermissions.menu_data, navigate))

			console.log('menumenumenumenumenumenumenu', menu)
			// setRoleMenuAndPermissionsData(convertMenuData(roleMenuAndPermissions, navigate))
			const updatedData = menu.filter(
				(item: any) => item.label !== "User Management"
			);
			const updatedOriginalMenuData = roleMenuAndPermissions.menu_data.filter(
				(item: any) => item.name !== "User Management"
			);
			dispatch(setSelectedDrawerMenu({
				menu: isAdminUser === 500 ? updatedData : menu,
				screenFirstPoint: roleMenuAndPermissions.screenFirstPoint,
				screenPermissions: roleMenuAndPermissions.screenPermissions,
				originalMenu: isAdminUser === 500 ? updatedOriginalMenuData : roleMenuAndPermissions.menu_data
			}));


			// if (roleMenuAndPermissions && roleMenuAndPermissions.length > 0 && roleMenuAndPermissions[0].name === 'Home' && roleMenuAndPermissions[0]?.items.length > 0) {
			// 	dispatch(setSelectedHomePage({ path: roleMenuAndPermissions[0].items[0].url }));
			// }
		}
	}, [roleMenuAndPermissions])

	// const roleMenuAndPermissionsData = convertMenuData(roleMenuAndPermissions, navigate);




	// const { isLoading, data } = useAccountants({
	// 	search_query: "",
	// 	order_by: "acc_title",
	// 	order_direction: "asc",
	// 	page: 1,
	// 	size: 25,
	// }, isAdminUser, selectedAccountantId);
	// const accountantList: any = data;
	// const [menu, setMenu] = useState<any>(AdminRoutes);


	consoleValue(
		`@@@@@@=> isAdminUser: ${isAdminUser}, 
		token: ${token}, 
	  selectedAccountantId: ${selectedAccountantId}, 
	  selectedAccountantName: ${selectedAccountantName}, 
	  selectedClientId: ${selectedClientId},  
	  selectedClientName: ${selectedClientName},  
	  selectedYear: ${selectedYear}, 
	  HomePagePath: ${HomePagePath}
	  selectedMenuItem: ${selectedMenuItem.id}
	  drawerAction: ${drawerAction}
	  subMenuVisibility: ${subMenuVisibility}
	  drawerMenu: ${drawerMenu.menu}
	  activityLog: ${activityLog.screenName}
	  stickyNavBar: ${stickyNavBar}
	  canada: ${countryAndProvincesInfo.canada}
	  canadaProvinces: ${countryAndProvincesInfo.canadaProvinces}
	  dashboardApisData => provincesForTDForm: ${dashboardApisData.provincesForTDForm}
	  screenFirstPoint: ${drawerMenu.screenFirstPoint}
	  companyAccountantName: ${companyAccountantName}
	  lastBankScreen: ${lastBankScreen}
	  companySequenceNumber: ${companySequenceNumber}
	  `
	);


	// const enhancedMenuItems = useMemo(() => {
	//     const enhancedItems = drawerMenu && drawerMenu.menu && drawerMenu.menu.map((item:any) => ({
	//       ...item,
	//       expanded: item.expanded ? item.expanded : false,
	//     }));
	//     enhancedItems && enhancedItems.push({
	//       label: "Logout",
	//       icon: 'pi pi-sign-out',
	//       command: () => {
	//           navigate("/logout")
	//       },
	//     });
	//   return enhancedItems
	//   // return[]
	// }, [drawerMenu]);
	const enhancedMenuItems = useMemo(() => {
		if (drawerMenuOptions.menu.length > 0) {
			const enhancedItems =
				drawerMenuOptions &&
				drawerMenuOptions.menu &&
				drawerMenuOptions.menu.map((item: any) => ({
					...item,
					hideLabel: item.label === 'Settings' ? true : false,
					expanded: item.expanded ? item.expanded : false,
				}));
			// enhancedItems &&
			// 	enhancedItems.push({
			// 		label: "Logout",
			// 		// icon: "pi pi-sign-out",
			// 		// icon: <LogoutIcon/>,
			// 		command: () => {
			// 			navigate("/logout");
			// 		},
			// 	});
			return enhancedItems;
		} else {
			const enhancedItems =
				drawerMenu &&
				drawerMenu.menu &&
				drawerMenu.menu.map((item: any) => ({
					...item,
					hideLabel: item.label === 'Settings' ? true : false,
					expanded: item.expanded ? item.expanded : false,
				}));
			// enhancedItems &&
			// 	enhancedItems.push({
			// 		label: "Logout",
			// 		// icon: "pi pi-sign-out",
			// 		// icon: <LogoutIcon/>,
			// 		command: () => {
			// 			navigate("/logout");
			// 		},
			// 	});
			return enhancedItems;
		}
		// return[]
	}, [drawerMenu, drawerMenuOptions]);




	let selectedMainItem = {
		label: "Accountant",
	};
	const subItems =
		enhancedMenuItems &&
		enhancedMenuItems.find((item: any) => item.label === appBarSelectedItem);

	// useEffect(() => {
	// 	if (isAdminUser === 400) {
	// 		if (selectedClientId && selectedClientId.length > 0) {
	// 			// dispatch(setSelectedHomePage({ path: "/clients/dashboard" }));

	// 			dispatch(setSelectedDrawerMenu({ menu: AdminClientRoutes }));
	// 			// setMenu(AdminClientRoutes);
	// 		} else if (selectedAccountantId && selectedAccountantId.length > 0) {
	// 			// dispatch(setSelectedHomePage({ path: "/accountants/clients" }));

	// 			dispatch(setSelectedDrawerMenu({ menu: AdminAccountantRoutes }));
	// 			// setMenu(AdminAccountantRoutes);
	// 		} else {
	// 			// dispatch(setSelectedHomePage({ path: "/global-search" }));

	// 			dispatch(setSelectedDrawerMenu({ menu: AdminRoutes }));
	// 			// setMenu(AdminRoutes);
	// 		}
	// 	} else {
	// 		// alert("Only Admin can Login So, Please provide Admin Username or Password!")
	// 		// if (selectedClientId && selectedClientId.length > 0) {
	// 		//   setMenu(ClientRoutes)
	// 		// } else {
	// 		//   setMenu(ClientListRoutes);
	// 		// }
	// 		// if (selectedAccountantId && selectedAccountantId.length > 0) {
	// 		//   setMenu(ClientListRoutes);
	// 		// }
	// 		// else {
	// 		//     setMenu(AccountantListRoutes);
	// 		//   }
	// 		if (selectedClientId && selectedClientId.length > 0) {
	// 			dispatch(setSelectedHomePage({ path: "/clients/dashboard" }));
	// 			dispatch(setSelectedDrawerMenu({ menu: ClientRoutes }));
	// 			// setMenu(ClientRoutes);
	// 		} else if (selectedAccountantId && selectedAccountantId.length > 0) {
	// 			dispatch(setSelectedHomePage({ path: "/accountants/clients" }));

	// 			if (
	// 				accountantList &&
	// 				accountantList.items &&
	// 				accountantList.items.length !== 0
	// 			) {

	// 				dispatch(
	// 					setSelectedDrawerMenu({ menu: ClientListRoutesWithAccountant })
	// 				);
	// 				// setMenu(ClientListRoutesWithAccountant);
	// 			} else {
	// 				dispatch(setSelectedDrawerMenu({ menu: ClientListRoutes }));
	// 				// setMenu(ClientListRoutes);
	// 			}
	// 		} else {
	// 			dispatch(setSelectedHomePage({ path: "/accountants" }));
	// 			dispatch(setSelectedDrawerMenu({ menu: AccountantListRoutes }));
	// 			// setMenu(AccountantListRoutes);
	// 		}
	// 	}

	// 	// if (
	// 	// 	accountantList &&
	// 	// 	accountantList.message &&
	// 	// 	accountantList.message.detail === "Invalid token or expired token."
	// 	// ) {
	// 	// 	let path = "/logout";
	// 	// 	navigate(path);
	// 	// }
	// }, [accountantList, selectedClientId, selectedAccountantId]);


	// for panelMenu

	// after using panel menu form prime react Im facing one issue like when I reload screen then selected item backgound color disables
	// so I have to manage that bug and fix by using this lines of code below 
	const [activePath, setActivePath] = useState<string | null>(null);
	// Flatten menu to find item by path
	const findActiveItem = (items: any[], pathname: string): any | null => {

		if (items) {
			for (const item of items) {
				if (item.path && pathname.startsWith(item.path)) {
					return item;
				}
				if (item.items) {
					const found = findActiveItem(item.items, pathname);
					if (found) return found;
				}
			}
		}
		return null;
	};
	const model = subItems && subItems.items ? subItems.items : subItems && subItems;
	// On location change, detect which menu item matches
	useEffect(() => {
		if (isSmallScreenMenu) {
			let currentPath = location.hash ? location.hash.replace(/^#/, "") : location.pathname;

			const activeItem = findActiveItem(enhancedMenuItems, currentPath);
			if (activeItem) {
				setActivePath(activeItem.path); // 👈 use path, not label
			}
		} else {
			let currentPath = location.hash ? location.hash.replace(/^#/, "") : location.pathname;

			const activeItem = findActiveItem(model, currentPath);
			if (activeItem) {
				setActivePath(activeItem.path); // 👈 use path, not label
			}
		}

	}, [isSmallScreenMenu, location, model]);
	const panelMenuPT: any = {
		header: ({ context, props }: any) => {
			const item = props.model?.[context.index];
			const isActive = item && item.path && item.path === activePath;

			return {
				className: classNames(props.className, {
					"custom-active-header": isActive
				}),
				onClick: (e: React.MouseEvent<HTMLDivElement>) => {
					props.onClick?.(e);
					if (item?.command) {
						item.command();
					}
				}
			};
		},
		content: ({ context, props }: any) => {
			const item = context.item?.item ?? context.item;

			const isActive = item?.path && item.path === activePath;
			return {
				className: classNames(props.className, {
					"custom-active": isActive
				}),
				onClick: (e: React.MouseEvent<HTMLDivElement>) => {

					props.onClick?.(e);
					if (item?.command) {
						item.command();
					}
					if (item?.path) {
						setActivePath(item.path);
						navigate(item.path);
					}
				}
			};
		},
	};
	// const panelMenuPT: any = {
	// 	content: ({ context, props }: any) => {
	// 		const item = context.item?.item ?? context.item;

	// 		const isActive = item?.path && item.path === activePath;
	// 		
	// 		return {
	// 			className: classNames(props.className, {
	// 				"custom-active": isActive
	// 			}),
	// 			onClick: (e: React.MouseEvent<HTMLDivElement>) => {

	// 				props.onClick?.(e);
	// 				if (item?.command) {
	// 					item.command();
	// 				}
	// 				if (item?.path) {
	// 					setActivePath(item.path);
	// 					navigate(item.path);
	// 				}
	// 			}
	// 		};
	// 	},
	// };

	const itemTemplate = (item: any, options: any) => {
		const isActive = item.path && item.path === activePath;

		return (
			<div className={classNames("p-menuitem-content", { "custom-active": isActive })}>
				<a
					className={options.className}
					onClick={(e) => {
						options.onClick(e);
						if (item.path) {
							setActivePath(item.path);
							navigate(item.path);
						}
					}}
				>
					{item.icon && <span className={classNames(item.icon, "p-menuitem-icon")} />}
					<span className="p-menuitem-text">{item.label}</span>
					{options.submenuIcon}
				</a>
				{options.children}
			</div>
		);
	};

	// return <LeftMenu menuItems={menu} />;
	// return <PanelMenu model={enhancedMenuItems} />;
	// return <MultiLevelDrawer menuItems={subItems && subItems.items ? subItems.items : subItems} />;
	return isAppBar ? (
		<SingleMenubar menuItems={enhancedMenuItems} />
	) : isSmallScreenMenu ? (
		<PanelMenu
			model={enhancedMenuItems}
			pt={panelMenuPT}
		/>
	) : (
		// this would use when we are using submenu bar
		// go to EnhancedAppBar.tsx uncomment subMenuVisible to show submenu bar 
		// <MultiLevelDrawer
		// 	menuItems={subItems && subItems.items ? subItems.items : subItems}
		// />

		// panelManu use when we want to use multi level menu 
		// also add path inside component when set draweroption in store
		// also add some styling in .css file
		// also search "for panelMenu" add all lines below this tag
		<PanelMenu
			model={subItems && subItems.items ? subItems.items : subItems}
			pt={panelMenuPT}
		// model={
		// isFlat
		// 	? subItems?.items.map((i: any) => ({ ...i, template: itemTemplate })) // attach template per item
		// 	: subItems?.items
		// }
		// pt={!isFlat ? panelMenuPT : undefined}
		/>
	);
};

//  {
//             "name": "Compliance",
//             "menuOrder": 7,
//             "menuParentId": null,
//             "items": [
//                 {
//                     "name": "T4",
//                     "category": "Slips",
//                     "menuOrder": 1,
//                     "menuParentId": "695cdf7ce18e1a110929b0be",
//                     "items": [
//                         {
//                             "name": "List",
//                             "url": "/compliance/t4/list",
//                             "menuOrder": 1,
//                             "menuParentId": "6960a969ade98283c4cf8501"
//                         },
//                         {
//                             "name": "Setup",
//                             "url": "/compliance/t4/setup",
//                             "menuOrder": 2,
//                             "menuParentId": "6960a969ade98283c4cf8501"
//                         },
//                         {
//                             "name": "Summary",
//                             "url": "/compliance/t4/summary",
//                             "menuOrder": 3,
//                             "menuParentId": "6960a969ade98283c4cf8501"
//                         },
//                         {
//                             "name": "Summary Reduced EI",
//                             "url": "/compliance/t4/summary-reduced-ei",
//                             "menuOrder": 4,
//                             "menuParentId": "6960a969ade98283c4cf8501"
//                         }
//                     ]
//                 },
//                 {
//                     "name": "RL-1",
//                     "menuOrder": 2,
//                     "category": "Slips",
//                     "menuParentId": "695cdf7ce18e1a110929b0be",
//                     "items": [
//                         {
//                             "name": "List",
//                             "url": "/compliance/rl1/list",
//                             "menuOrder": 1,
//                             "menuParentId": "6960a982ade98283c4cf850f"
//                         },
//                         {
//                             "name": "Setup",
//                             "url": "/compliance/rl1/setup",
//                             "menuOrder": 2,
//                             "menuParentId": "6960a982ade98283c4cf850f"
//                         },
//                         {
//                             "name": "Summary",
//                             "url": "/compliance/rl1/summary",
//                             "menuOrder": 3,
//                             "menuParentId": "6960a982ade98283c4cf850f"
//                         },
//                         {
//                             "name": "Settings",
//                             "url": "/compliance/rl1/settings",
//                             "menuOrder": 4,
//                             "menuParentId": "6960a982ade98283c4cf850f"
//                         }
//                     ]
//                 },
//                 {
//                     "name": "TD1",
//                     "menuOrder": 3,
//                     "category": "Forms",
//                     "menuParentId": "695cdf7ce18e1a110929b0be",
//                     "items": [
//                         {
//                             "name": "Federal",
//                             "url": "/td1/federal",
//                             "menuOrder": 1,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "AB",
//                             "url": "/td1/alberta",
//                             "menuOrder": 2,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "BC",
//                             "url": "/td1/british_columbia",
//                             "menuOrder": 3,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "MB",
//                             "url": "/td1/manitoba",
//                             "menuOrder": 4,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "NB",
//                             "url": "/td1/new_brunswick",
//                             "menuOrder": 5,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "NL",
//                             "url": "/td1/newfoundland_and_labrador",
//                             "menuOrder": 6,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "NT",
//                             "url": "/td1/northwest_territories",
//                             "menuOrder": 7,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "NS",
//                             "url": "/td1/nova_scotia",
//                             "menuOrder": 8,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "NU",
//                             "url": "/td1/nunavut",
//                             "menuOrder": 9,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "ON",
//                             "url": "/td1/ontario",
//                             "menuOrder": 10,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "PE",
//                             "url": "/td1/prince_edward_island",
//                             "menuOrder": 11,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "QC",
//                             "url": "/td1/quebec",
//                             "menuOrder": 12,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "SK",
//                             "url": "/td1/saskatchewan",
//                             "menuOrder": 13,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         },
//                         {
//                             "name": "YT",
//                             "url": "/td1/yukon",
//                             "menuOrder": 14,
//                             "menuParentId": "6960a99dade98283c4cf851e"
//                         }
//                     ]
//                 },
//                 {
//                     "name": "ROE",
//                     "menuOrder": 4,
//                     "category": "Forms",
//                     "menuParentId": "695cdf7ce18e1a110929b0be",
//                     "items": [
//                         {
//                             "name": "List",
//                             "url": "/compliance/roe/list",
//                             "menuOrder": 1,
//                             "menuParentId": "69eb36a7cbead60539301211"
//                         },
//                         {
//                             "name": "Create",
//                             "url": "/compliance/roe/setup",
//                             "menuOrder": 2,
//                             "menuParentId": "69eb36a7cbead60539301211"
//                         },
//                         {
//                             "name": "Web",
//                             "url": "/compliance/roe/web",
//                             "menuOrder": 3,
//                             "menuParentId": "69eb36a7cbead60539301211"
//                         }
//                     ]
//                 }
//             ]
//         },